import React, {FC} from 'react';
import {usePersonalizeCmp} from './hooks/usePersonalizeCmp';
import {SideBarContent} from '../../SideBarContent';
import {ETargetAutoFill} from '../../../RichText/types';

export interface IPersonalizeCmpProps {
    targetAutoFill: React.MutableRefObject<ETargetAutoFill>;
    messageCursorLastPosition: React.MutableRefObject<number>;
    subjectInputRef: React.MutableRefObject<HTMLInputElement>;
}

export const PersonalizeCmp: FC<IPersonalizeCmpProps> = ({
    messageCursorLastPosition,
    subjectInputRef,
    targetAutoFill
}) => {
    const {renderHeader, renderBody, renderFooter} = usePersonalizeCmp({
        messageCursorLastPosition,
        subjectInputRef,
        targetAutoFill
    });

    return <SideBarContent {...{renderHeader, renderBody, renderFooter}} />;
};
